module.exports = __webpack_public_path__ + "static/media/hourglass-start.6790a65b.svg";